import { useEffect, useState } from 'react';

/**
 * Custom hook to automatically calculate map zoom level based on search radius
 * Higher zoom = zoomed in more = less area visible
 * Smaller radius = higher zoom (more detail, less area)
 * Larger radius = lower zoom (less detail, more area)
 * 
 * @param radius - Search radius in miles (null means no radius set)
 * @returns Current zoom level (defaults to 12.5 for 10mi)
 */
export function useMapZoom(radius: number | null): number {
  const [mapZoom, setMapZoom] = useState(11.5); // Default zoom - less zoomed in to see radius

  useEffect(() => {
    if (!radius) return;
    
    // Rough zoom levels based on radius (miles) - less zoomed in to show full radius
    if (radius <= 10) {
      setMapZoom(11.5); // Show ~15-20 miles (less zoomed in to see 10mi radius)
    } else if (radius <= 25) {
      setMapZoom(10.5); // Show ~25-30 miles (less zoomed in to see 25mi radius)
    } else if (radius <= 50) {
      setMapZoom(9.5);
    } else if (radius <= 100) {
      setMapZoom(8.5);
    } else if (radius <= 250) {
      setMapZoom(7.5);
    } else {
      setMapZoom(6.5);
    }
  }, [radius]);

  return mapZoom;
}

